import { render, staticRenderFns } from "./TopProductsList.vue?vue&type=template&id=6eed508d"
import script from "./TopProductsList.vue?vue&type=script&lang=js"
export * from "./TopProductsList.vue?vue&type=script&lang=js"
import style0 from "./TopProductsList.vue?vue&type=style&index=0&id=6eed508d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports